/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit RemoveAction/view.blocks to change it.
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaIconDelete from 'DesignSystem/Svgs/TysiaIconDelete/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function RemoveAction({
  children,
  viewPath = "/App/Account/NewPatient/Content/Form/ReferralsSection/Referrals/Referral/RemoveAction"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<button
  data-testid="RemoveAction.Vertical"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 className={`views-block ${styles.Vertical}`}
>
<TysiaIconDelete
  viewPath={`${viewPath}/TysiaIconDelete`}
/>
</button>
{children}
</React.Fragment>)
}